module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-15-0d93d7b4521e7aaebe63f8a9a0fc7cf4.jpg";